import { fetchJsonResource } from './fetchJsonResource';
import { normalizeRedesignAccount } from './readRedesignAccount';

const ROUTE_NAME = 'evp_ticket_frontend.account_state';

async function fetchRedesignAccount({ signal } = {}) {
    return normalizeRedesignAccount(await fetchJsonResource(ROUTE_NAME, undefined, { signal }));
}

export default fetchRedesignAccount;
export { ROUTE_NAME };
